export const karviuProduktyvumasStulpeliai = [
  { width: 92, label: "Mėnesis", dataKey: "menesis" },
  { width: 125, label: "Banda", dataKey: "banda" },
  { width: 150, label: "Karvės nr.", dataKey: "karve" },
  { width: 185, label: "Veislė", dataKey: "veisle" },

  { width: 121, label: "Dabartinės laktacijos #", dataKey: "dab_lak_nr" },
  { width: 120, label: "Dabartinės laktacijos pradžia", dataKey: "dab_lak_pr" },
  { width: 100, label: "Dabartinės laktacijos trukmė", dataKey: "dab_lak_trukme" },
  { width: 110, label: "Dabartinės laktacijos pienas kg", dataKey: "dab_lak_pienas" },
  {
    width: 95,
    label: "Dabartinės laktacijos R+B kg",
    dataKey: "dab_lak_rieb_balt",
  },

  { width: 110, label: `Laktacijos "1" pienas kg`, dataKey: "lak_1_pienas" },
  { width: 90, label: `Laktacijos "1" R+B kg`, dataKey: "lak_1_rieb_balt" },

  { width: 110, label: `Laktacijos "2" pienas kg`, dataKey: "lak_2_pienas" },
  { width: 90, label: `Laktacijos "2" R+B kg`, dataKey: "lak_2_rieb_balt" },

  { width: 110, label: `Laktacijos "3" pienas kg`, dataKey: "lak_3_pienas" },
  { width: 90, label: `Laktacijos "3" R+B kg`, dataKey: "lak_3_rieb_balt" },

  { width: 110, label: `Laktacijų "4-5" pienas kg`, dataKey: "lak_4_5_pienas" },
  { width: 90, label: `Laktacijų "4-5" R+B kg`, dataKey: "lak_4_5_rieb_balt" },

  { width: 110, label: `Laktacijų "5+" pienas kg`, dataKey: "lak_5plus_pienas" },
  { width: 90, label: `Laktacijų "5+" R+B kg`, dataKey: "lak_5plus_rieb_balt" },
];

export const karviuProduktyvumasStulpeliaiMultiHeader = {
  singleHeader: [
    { width: 92, label: "Mėnesis", dataKey: "menesis", excelCellWidth: 9 },
    { width: 125, label: "Banda", dataKey: "banda", excelCellWidth: 13 },
    { width: 150, label: "Karvės nr.", dataKey: "karve", excelCellWidth: 16 },
    { width: 135, label: "Gimimo data", dataKey: "gimimo_data", excelCellWidth: 13 },
    { width: 185, label: "Veislė", dataKey: "veisle", excelCellWidth: 19 },
  ],
  nestedHeader: [
    {
      title: "Einamosios laktacijos duomenys",
      width: 580,
      children: [
        { width: 80, label: "Numeris", dataKey: "dab_lak_nr", excelCellWidth: 9 },
        { width: 150, label: "Pradžia", dataKey: "dab_lak_pr", excelCellWidth: 11 },
        { width: 90, label: "Trukmė", dataKey: "dab_lak_trukme", excelCellWidth: 8 },
        { width: 90, label: "Pienas kg", dataKey: "dab_lak_pienas", excelCellWidth: 8 },
        { width: 90, label: "R+B kg", dataKey: "dab_lak_rieb_balt", excelCellWidth: 6 },
      ],
    },
    {
      title: "Buvusių laktacijų duomenys (kg)",
      width: 1000,
      excelCellWidth: 10,
      children: [
        {
          group: "Bendri vidurkiai",
          width: 200,
          children: [
            { width: 90, label: "Pienas", dataKey: "buvusiu_pieno_vidurkis", excelCellWidth: 7 },
            { width: 90, label: "R+B", dataKey: "buvusiu_rb_vidurkis", excelCellWidth: 7 },
          ],
        },
        {
          group: "1",
          width: 150,
          excelCellWidth: 10,
          children: [
            { width: 75, label: "Pienas", dataKey: "lak_1_pienas", excelCellWidth: 7 },
            { width: 75, label: "R+B", dataKey: "lak_1_rieb_balt", excelCellWidth: 6 },
          ],
        },
        {
          group: "2",
          width: 150,
          excelCellWidth: 10,
          children: [
            { width: 75, label: "Pienas", dataKey: "lak_2_pienas", excelCellWidth: 7 },
            { width: 75, label: "R+B", dataKey: "lak_2_rieb_balt", excelCellWidth: 6 },
          ],
        },
        {
          group: "3",
          width: 150,
          excelCellWidth: 10,
          children: [
            { width: 75, label: "Pienas", dataKey: "lak_3_pienas", excelCellWidth: 7 },
            { width: 75, label: "R+B", dataKey: "lak_3_rieb_balt", excelCellWidth: 6 },
          ],
        },
        {
          group: "4-5",
          width: 150,
          excelCellWidth: 10,
          children: [
            { width: 75, label: "Pienas", dataKey: "lak_4_5_pienas", excelCellWidth: 7 },
            { width: 75, label: "R+B", dataKey: "lak_4_5_rieb_balt", excelCellWidth: 6 },
          ],
        },
        {
          group: "5+",
          width: 150,
          excelCellWidth: 10,
          children: [
            { width: 75, label: "Pienas", dataKey: "lak_5plus_pienas", excelCellWidth: 7 },
            { width: 75, label: "R+B", dataKey: "lak_5plus_rieb_balt", excelCellWidth: 6 },
          ],
        },
      ],
    },
  ],
};

export const karviuRodikliuStulpeliai = [
  //[x]: fix excelCellWidth for all columns
  {
    width: 150,
    label: "Mėnesis",
    dataKey: "menesis",
    excelCellWidth: 9,
    formatting: (value) => ({
      style: { whiteSpace: "nowrap" },
    }),
  },
  {
    width: 150,
    label: "Būklė",
    dataKey: "bukle",
    formatting: (value, row) => ({
      color:
        value === "v" && row.trukme > 400
          ? "red"
          : value === "u" && row.uztruk_dienos < 30
          ? "red"
          : value === "u" && row.uztruk_dienos > 60
          ? "rgb(31, 78, 121)"
          : value === null
          ? "red"
          : (value === "n" && row.trukme > 110 && row.servis === null) || row.servis === 110
          ? "red"
          : "black",
      text:
        value === "s"
          ? "Sėklinta"
          : value === "n"
          ? "Nesėklinta"
          : value === "u"
          ? "Užtrūkusi"
          : value === "v"
          ? "Veršinga"
          : "Nežinoma",
    }),
    excelCellWidth: 12,
  },
  { width: 90, label: "Amžius lakt.", dataKey: "nr", excelCellWidth: 12 },
  { width: 90, label: "Lakt. trukmė", dataKey: "trukme", excelCellWidth: 12 },
  { width: 100, label: "P (kg) einamoji", dataKey: "pienas", excelCellWidth: 12 },
  { width: 100, label: "P (kg) vid. buvusių", dataKey: "visasPienasVid", excelCellWidth: 11 },
  {
    width: 90,
    label: "P (kg) bazinis",
    dataKey: "bazinis",
    formatting: (value) => ({ color: value < 10 ? "red" : "black" }),
    excelCellWidth: 8,
  },
  {
    width: 90,
    label: "P (kg) faktinis",
    dataKey: "primilzis",
    formatting: (value) => ({ color: value < 10 ? "red" : "black" }),
    excelCellWidth: 8,
  },
  {
    width: 90,
    label: "R (%)",
    dataKey: "rieb",
    formatting: (value) => ({ color: value < 3.4 ? "red" : "black" }),
    excelCellWidth: 8,
  },
  {
    width: 90,
    label: "B (%)",
    dataKey: "balt",
    formatting: (value) => ({ color: value < 3 ? "red" : "black" }),
    excelCellWidth: 8,
  },
  {
    width: 100,
    label: "R/B (%)",
    dataKey: "rb",
    formatting: (value) => ({ color: value < 1 || value > 1.4 ? "red" : "black" }),
    excelCellWidth: 10,
  },
  {
    width: 90,
    label: "L (%)",
    dataKey: "lak",
    formatting: (value) => ({ color: value < 4 ? "red" : "black" }),
    excelCellWidth: 8,
  },
  {
    width: 100,
    label: "U (mg%)",
    dataKey: "urea",
    formatting: (value) => ({ color: value < 15 || value > 30 ? "red" : "black" }),
    excelCellWidth: 8,
  },
  {
    width: 125,
    label: "SLS (tūkst./ml)",
    dataKey: "sls",
    formatting: (value) => ({ color: value > 400 ? "red" : "black" }),
    excelCellWidth: 12,
  },
  {
    width: 95,
    label: "SLS 200 4k.",
    dataKey: "sls200k",
    formatting: (value) => ({
      color: value !== null ? "red" : null,
      text: value !== null ? "*" : null,
    }),
    excelCellWidth: 12,
  },
  {
    width: 95,
    label: "SLS 400 4k.",
    dataKey: "sls400k",
    formatting: (value) => ({
      color: value !== null ? "red" : null,
      text: value !== null ? "*" : null,
    }),
    excelCellWidth: 12,
  },
  {
    width: 100,
    label: "Sėkl. kartai",
    dataKey: "seklinimai",
    formatting: (value) => ({ color: value > 3 ? "red" : "black" }),
    excelCellWidth: 12,
  },
  { width: 100, label: "Servis", dataKey: "servis", excelCellWidth: 11 },
  { width: 100, label: "Dienos tarp apsiv.", dataKey: "apsiv_inter", excelCellWidth: 12 },
  {
    width: 100,
    label: "Užtrūkimo dienos",
    dataKey: "uztruk_dienos",
    excelCellWidth: 12,
    formatting: (value) => ({
      color: value < 30 ? "red" : value > 60 ? "rgb(31, 78, 121)" : "black",
    }),
  },
  { width: 100, label: "Veršingumo dienos", dataKey: "versingu_inter", excelCellWidth: 12 },
];
